import React from 'react'
import '../assets/css/NewProjects.css'
import Card from './Card'
import LogoCorven from '../assets/static/Logo-Corven.webp'
import LogoDR from '../assets/static/Logo-DR.png'
import LogoGif from '../assets/static/logo-gif.png'
import LogoNPM from '../assets/static/logonpm.png'
import useNearScreen from '../hooks/useNearScreen'


export default function NewProjects() {
  const {isNearScreen, fromRef} = useNearScreen({ distance: '-70px'})
  return (
    <div ref={fromRef} className='NewProjects'>
      <h2
        className={isNearScreen ? 'NewProjects-Title' : 'NewProjects-Title NewProjects-Title-dis'}>
        Projects
      </h2>
      <div className={isNearScreen ? "NewProjects-Container" : "NewProjects-Container NewProjects-Container-dis"}>
        <div className='Card-Container'>
        <Card
        description='I created this e-commerce because the hosting of the original e-commerce had problems all the time, and at my job we couldn&apos;t sell normally.'
        title='Corven E-Commerce'
        logo={LogoCorven}
        git='https://github.com/NahuelOrselli/CorvenEcommerceDemo'
        page='https://corven-demo.web.app/'
        isNear={isNearScreen}
        />
        </div>
        <div className='Card-Container'>
        <Card
        description='It&apos;s a personal project, I&apos;ve created this game because I love the RPG Games.'
        title='Dungeons&ReactJS'
        logo={LogoDR}
        page='https://dungeons-reactjs.web.app/'
        isNear={isNearScreen}
        />
        </div>
        <div className='Card-Container'>
        <Card
        description='This is a project from Youtuber Midudev&apos;s React course'
        title='Gif Searcher'
        logo={LogoGif}
        git='https://github.com/NahuelOrselli/GifSearcher'
        page='https://gifsearch-nahuelorselli.vercel.app/'
        isNear={isNearScreen}
        />
        </div>
        <div className='Card-Container'>
        <Card
        description='The react-firework package npm contains a React Component with firework animation.'
        title='React Firework'
        logo={LogoNPM}
        git='https://github.com/NahuelOrselli/react-firework'
        page='https://www.npmjs.com/package/react-firework'
        isNear={isNearScreen}
        />
        </div>
      </div>
    </div>
  )
}
